import { useEffect, useState } from "react";
import { Celebration } from "./components/Celebration";
import { HomeScreen } from "./components/HomeScreen";
import { InvestScreen } from "./components/InvestScreen";
import { Onboarding } from "./components/Onboarding";
import { PortfolioScreen } from "./components/PortfolioScreen";
import { SettingsScreen } from "./components/SettingsScreen";
import { TabBar, type Tab } from "./components/TabBar";
import { dismissCelebration, initApp, useAppState } from "./lib/store";

export default function App() {
  const s = useAppState();
  const [tab, setTab] = useState<Tab>("home");

  useEffect(() => {
    void initApp();
  }, []);

  if (!s.ready) {
    return (
      <div className="screen" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ fontSize: 40 }}>🪙</div>
      </div>
    );
  }

  if (!s.settings.onboarded) {
    return <Onboarding />;
  }

  return (
    <>
      {tab === "home" && <HomeScreen />}
      {tab === "invest" && <InvestScreen />}
      {tab === "portfolio" && <PortfolioScreen />}
      {tab === "settings" && <SettingsScreen />}
      <TabBar tab={tab} onChange={setTab} />
      {s.celebration && <Celebration payload={s.celebration} onDone={dismissCelebration} />}
    </>
  );
}
